document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".custom-collection-section");

  sections.forEach(section => {

    /* MOBILE FONT SCALE */
    function adjustMobileFonts() {
      const isMobile = window.innerWidth <= 768;

      section.querySelectorAll("[data-desktop-size]")
        .forEach(el => {
          const size = el.getAttribute("data-desktop-size");
          el.style.fontSize = isMobile ? (size * 0.75) + "px" : size + "px";
        });
    }

    adjustMobileFonts();
    window.addEventListener("resize", adjustMobileFonts);


    /* ANIMATION */
    if (section.dataset.animation !== "true") return;

    const type = section.dataset.animationType;
    const direction = section.dataset.direction;
    const speed = section.dataset.speed;

    const items = section.querySelectorAll(".animate-item");

    items.forEach(item => {

      const delay = item.dataset.delay || 0;

      item.style.transitionDuration = speed + "ms";
      item.style.transitionDelay = delay + "ms";

      if (type === "slide-fade") {
        switch(direction) {
          case "left":
            item.style.transform = "translateX(-40px)";
            break;
          case "right":
            item.style.transform = "translateX(40px)";
            break;
          case "top":
            item.style.transform = "translateY(-40px)";
            break;
          default:
            item.style.transform = "translateY(40px)";
        }
      }
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    }, { threshold: 0.2 });

    items.forEach(item => observer.observe(item));

  });

});